import {getDomain} from '../help/url';
import {URLS} from 'fire-wind-water';

const d = window as any;
const skconf = d.skConfig || {};

export const config: { [label: string]: string | number } = {
  apiUrl: skconf.apiUrl || '//api.industrysourcing.cn',
  apiCacheUrl: skconf.apiCacheUrl || '//static.industrysourcing.cn/',
  sbaseUrl: skconf.sbaseUrl || '//cgi.industrysourcing.cn/content/',
  shortUrl: skconf.shortUrl || '//cgi.industrysourcing.cn/u/',
  matomoUrl: skconf.matomoUrl || '//cgi.industrysourcing.cn/matomo/',
  weChatOauthUrl: skconf.weChatOauthUrl || 'https://cgi.industrysourcing.cn/wxouthb/public/wx_interface/auth',
  usercenterUrl: skconf.usercenterUrl || '//console.industrysourcing.cn/spersonalcenter/',
  webinarPosterQrCodeUrl: skconf.webinarPosterQrCodeUrl || 'https://cgi.industrysourcing.cn/wxouthb/wbr/poster',
  webinarPosterUrl: skconf.webinarPosterUrl || '//console.industrysourcing.cn/f/webinarposter/index.html',
  webinarbInteractUrl: skconf.webinarbInteractUrl || '//cgi.industrysourcing.cn/',
  cdn: skconf.cdn || '//console.industrysourcing.cn/cdn',
  domain: skconf.domain || getDomain() || 'smarket.net.cn',
  tenantId: skconf.tenantId || URLS.getURL('tenantId')
};

